export const ALL_ORDER_STATES = ["Aceptado", "Aceptado sin Stock", "Rechazado", "Enviado", "Recibido"] // Estado undefined significa que el producto todavía no ha sido aceptado, no tiene estado
